module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_20.55b70db7.jpg";